import type { ColumnsType } from 'antd/es/table';
import axios, { type AxiosResponse } from 'axios';

import { COLUMNS } from './constants';
import type { RecordDetail, RouteDetail } from './types';

export const fetchRouteDetailData = async (params: {
  url: string;
  page: number;
  pageSize: number;
}) => {
  const { url, ...rest } = params;
  try {
    const { data: routeDetail }: AxiosResponse<RouteDetail> = await axios({
      url,
      method: 'GET',
      headers: {
        authorization: localStorage.getItem('feathers-jwt'),
      },
      params: rest,
    });
    return routeDetail;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export const getDetailTableColumns = (
  attachmentColumnRenderer: (value: string) => JSX.Element | null
) => {
  const newColumns: ColumnsType<RecordDetail> = COLUMNS.map((column) => {
    if (column.title === '附件') {
      return {
        ...column,
        render: (value) => attachmentColumnRenderer(value),
      };
    }
    return column;
  });
  return newColumns;
};
